/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Template_ParagraphInputs */



/**
* | output |
* | --- |
* | "Paragraph" |
*
* @param {Transcript_Export_Template_ParagraphInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_template_paragraph = /** @type {((inputs?: Transcript_Export_Template_ParagraphInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Template_ParagraphInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paragraphe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Absatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Paragrafo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Абзац")
	if (locale === "es") return /** @type {LocalizedString} */ ("Párrafo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("段落")
	if (locale === "ja") return /** @type {LocalizedString} */ ("段落")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुच्छेद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Parágrafo")
	return /** @type {LocalizedString} */ ("Paragraph")
});